export const BRAND = {
    name: "Checking In with Courtnie Baby Johnson",
    host: "Courtnie Johnson",
    email: "courtneybabyjohnson@gmail.com",
    facebook: "COURTNEYBABYJOHNSON",
    instagram: "COURTNEYBABYJOHNSON",
    facebookUrl: "https://www.facebook.com/COURTNEYBABYJOHNSON",
    instagramUrl: "https://www.instagram.com/COURTNEYBABYJOHNSON",
    tagline: "It's more than a podcast. It's a movement of real voices and real stories.",
    cry: ["Support local", "Support live music", "Support each other"],
    city: "Twin Cities, MN",
};

export const IMAGES = {
    heroMain:
        "https://images.unsplash.com/photo-1593697909683-bccb1b9e68a4?auto=format&fit=crop&w=1200&q=85",
    heroSecondary:
        "https://images.pexels.com/photos/6878180/pexels-photo-6878180.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bentoArtist:
        "https://images.pexels.com/photos/20697386/pexels-photo-20697386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bentoBts:
        "https://images.unsplash.com/photo-1554200876-907f9286c2a1?auto=format&fit=crop&w=1000&q=80",
    bentoShows:
        "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1000&q=80",
    bentoCommunity:
        "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=1000&q=80",
    skyline:
        "https://images.unsplash.com/photo-1567693221917-fefc994808ce?auto=format&fit=crop&w=1600&q=80",
    dj: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=1000&q=80",
    concert:
        "https://images.unsplash.com/photo-1563841930606-67e2bce48b78?auto=format&fit=crop&w=1000&q=80",
    studio:
        "https://images.unsplash.com/photo-1642437317106-5716114cfede?auto=format&fit=crop&w=1200&q=80",
};

export const NAV_LINKS = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Interviews", path: "/interviews" },
    { label: "Community Stories", path: "/community-stories" },
    { label: "Events", path: "/events" },
    { label: "Work With CBJ", path: "/work-with-cbj" },
    { label: "Contact", path: "/contact" },
];

export const INQUIRY_TYPES = [
    "Story idea",
    "Interview request",
    "Partnership or sponsorship",
    "Event coverage",
    "Media inquiry",
    "Something else",
];
